/*
 * Lift the Shopify Inbox chat bubble above the mobile sticky add-to-cart bar.
 *
 * Why JS: the bubble lives inside <shopify-chat>'s shadow root, which page CSS cannot reach,
 * and moving the full-screen host element would also shift the open chat window off screen.
 * So a style is injected into the shadow root and moves only the launcher.
 *
 * v2 (2026-09-17) — Manuel: after opening and closing the chat, the bubble landed back on top of
 * the Add to cart bar. Three changes:
 *   1. The selector no longer depends on the exact classes `.activator` / `.activator-nudge`.
 *      The widget rebuilds its launcher when the panel closes, and any other class name meant the
 *      rule stopped matching. Now: anything whose class contains "activator", plus a direct
 *      button/div child of the shadow root.
 *   2. The lift is measured from the real sticky-bar height (+10px), not hard-coded 84px, and is
 *      re-measured on resize / orientation change.
 *   3. The MutationObserver watches the SHADOW ROOT as well as document.body. Shadow-DOM changes
 *      are invisible to an observer on the page, which is why a rebuild went unnoticed.
 * Watch, don't retry: every path re-checks and re-applies, so nothing depends on winning a race.
 * Status for debugging from outside the page: window.__rpchat
 */
(function () {
  var STYLE_ID = 'rp-chat-offset';
  var status = (window.__rpchat = { applied: 0, offset: 0, skipped: '', observers: 0 });

  if (!window.matchMedia('(max-width: 749px)').matches) { status.skipped = 'desktop'; return; }

  function offsetPx() {
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar) return 0;
    var h = Math.round(bar.getBoundingClientRect().height);
    return (h > 0 ? h : 74) + 10;
  }

  // Manuel 2026-09-17: "the chat button bothers users, make it smaller and move it".
  // 0.8 scale from the bottom-right corner keeps it clear of the product cards it was covering,
  // and the tap target stays ~37px, above the ~32px people can reliably hit.
  var SCALE = 0.8;

  // MOVE ONLY — do not scale or hide anything in here.
  // 2026-09-17, two failed attempts on the live site, both reverted:
  //   scale(0.8) on every "activator*" element tore the launcher into two pieces (the button and
  //   its nudge bubble scale from their own corners), and hiding [class*="activator-nudge"] made
  //   the whole launcher disappear. The launcher's internal structure is Shopify's and it changes.
  //   To resize or reposition it, use the Shopify Inbox app's own appearance settings.
  function css(px) {
    // `:host >` only: [class*="activator"] alone also matched activator__icon and
    // activator__label INSIDE the button, so those children were moved a second time.
    // EXACT classes only. `[class*="activator"]` also matched activator__icon/__label inside the
    // button (moved twice); `:host >` matched nothing (the launcher is not a direct child).
    return '.activator, .activator-nudge {' +
      ' transform: translateY(-' + px + 'px) !important; }';
  }

  var shadowSeen = null;

  function apply() {
    if (!document.querySelector('sticky-add-to-cart')) { status.skipped = 'no sticky bar'; return; }
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (!root) return;

    if (root !== shadowSeen) {           // new shadow root -> watch inside it too
      shadowSeen = root;
      new MutationObserver(apply).observe(root, { childList: true, subtree: true });
      status.observers++;
    }

    var px = offsetPx();
    if (!px) return;
    var el = root.getElementById(STYLE_ID);
    if (el && el.dataset.px === String(px)) return;   // already correct: nothing to do, no loop
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      root.appendChild(el);
    }
    el.dataset.px = String(px);
    el.textContent = css(px);
    status.applied++;
    status.offset = px;
  }

  apply();
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  status.observers++;
  addEventListener('resize', apply);
  addEventListener('orientationchange', apply);
})();
